import type { App } from 'vue'
import { Vue3Mq, MqResponsive } from 'vue3-mq'

export default function (app: App) {
  app.use(Vue3Mq, {
    preset: 'bootstrap5', // 'bootstrap4', 'bootstrap5', 'tailwind' or 'bulma'
    // Custom breakpoints can be defined here
    breakpoints: {
      mobile: 0,
      tablet: 768,
      desktop: 1024,
      widescreen: 1216,
      fullhd: 1408
    }
  })
  
  app.component('MqResponsive', MqResponsive)
}
